window.setCookie = (args = {}) => {
    document.cookie = args.name + '=' + args.value + ((args.expires == null) ? "" : ";expires=" + args.expires.toGMTString());
};

window.getCookie = (name) => {
    let cookieName = name + "=";
    let docCookie = document.cookie;
    let cookieStart;
    let end;

    if (docCookie.length > 0) {
        cookieStart = docCookie.indexOf(cookieName);
        if (cookieStart !== -1) {
            cookieStart = cookieStart + cookieName.length;
            end = docCookie.indexOf(";", cookieStart);
            if (end === -1) {
                end = docCookie.length
            }
            return unescape(docCookie.substring(cookieStart, end))
        }
    }
    return false
};

window.disclaimerAllow = (e) => {
    let  expires = new Date();
    expires.setTime(new Date().getTime() + (24 * 60 * 60 * 1000)); // H * M * S * Ms

    let cookieData = {
        name: 'disclaimer',
        value: true,
        expires: expires,
    };

    setCookie(cookieData);
    $('#disclaimerModal').modal('hide');
    // document.location.reload()
};

window.disclaimerDeny = () => {
    window.location.href = 'https://www.google.fr'
};
